import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { colors } from '@iq/react-components';

import TopNotification from '../TopNotification';
import { getAggregatedSourceConnectivityByName } from '../../../bundles/sources';

const SourceConnectivityNotification = () => {
  const [notifications, setNotifications] = useState({});
  const aggregatedConnectivity = useSelector(getAggregatedSourceConnectivityByName);

  useEffect(() => {
    const updatedNotifications = { ...notifications };
    const aggEntries = Object.entries(aggregatedConnectivity);

    if (aggEntries.length === 0) setNotifications({});
    for (const [name, status] of aggEntries) {
      if (!updatedNotifications[name] && status === 0) {
        updatedNotifications[name] = {
          status,
          dismissed: false,
        };
      } else if (updatedNotifications[name]?.status !== status) {
        if (status === 0) {
          updatedNotifications[name].dismissed = false;
          updatedNotifications[name].status = status;
        } else {
          delete updatedNotifications[name];
        }
      }
    }
    setNotifications(updatedNotifications);
  }, [aggregatedConnectivity]);

  const onDismiss = (index) => {
    setNotifications((previous) => {
      const notificationKey = Object.keys(previous)[index];

      return {
        ...previous,
        [notificationKey]: {
          ...previous[notificationKey],
          dismissed: true,
        },
      };
    });
  };

  return (
    <>
      {Object.entries(notifications)
        .filter(([, status]) => !status.dismissed)
        .map(([name], index) => {
          const key = `name-${index}`;
          return (
            <TopNotification
              key={key}
              icon="he-disconnect"
              iconColor={colors.StatusRed}
              message={`${name} is disconnected!`}
              action={() => onDismiss(index)}
              actionText="Dismiss"
              activity="secondary"
            />
          );
        })}
    </>
  );
};

export default SourceConnectivityNotification;
